import React,{useEffect} from "react";
import { Link } from "react-router-dom";

import bannerImg from '../assets/images/visual-1.png'

import Navbar from "../components/navbar";
import BrandLogo from "../components/brandLogo";
import Features from "../components/features";
import AboutOne from "../components/aboutOne";
import AboutTwo from "../components/aboutTwo";
import AmazingFeatures from "../components/amazingFeatures";
import AboutThree from "../components/aboutThree";
import AboutFour from "../components/aboutFour";
import Pricing from "../components/pricing";
import Faq from "../components/Faq";
import Blogs from "../components/blogs";
import Footer from "../components/footer";
import Switcher from "../components/switcher";
import { useState } from "react";

import { TypeAnimation } from 'react-type-animation';


export default function IndexLight(){

    const [email, setEmail] = useState("");
    const [messagesub, setMessagesub]=useState("");
    const [privacyChecked, setPrivacyChecked] = useState(false);
    const [privacyChecked1, setPrivacyChecked1] = useState(false);
  
  
    const handleSubscribe = async (e) => {
      e.preventDefault(); // Prevent form reload
      setMessagesub("");
      setLoading(true);
  
      if (!email) {
        setMessagesub("Please enter your email.");
        setLoading(false);
        return;
      }
      if (!privacyChecked) {
        setMessagesub("Please agree to the privacy policy before subscribing.");
        setLoading(false);
        return;
      }
      
  
      try {
        const response = await fetch("https://api.brevo.com/v3/contacts", {
          method: 'POST',
          headers: {
            'accept': 'application/json',
            'api-key': process.env.REACT_APP_BREVO_API_KEY,
            'content-type': 'application/json',
          },
          body: JSON.stringify({
            listIds: [5], // Pass the list ID as an array
            updateEnabled: false, // Optional, set to true if you want to update existing contacts
            email: email, // The email address being subscribed
          }),
  
        });
  
        // Send the request to Brevo
      
        const data = await response.json();
        if (response.ok) {
          setMessagesub("Successfully joined the waitlist!");
          setEmail(""); // Reset email field
          return setMessagesub('Successfully joined the waitlist!');
        } else if (data.code === 'duplicate_parameter') {
          // Handle the case where the contact already exists
          return setMessagesub('You are already in waitlist!');
        } else {
          return setMessagesub('Joining to waitlist failed!');
        }
  
        
      } catch (error) {
        setMessagesub("Error subscribing. Please try again.");
      } finally {
        setLoading(false);
      }
  
    };
    
  
      
      const [formData, setFormData] = useState({
          name: "",
          email: "",
          comments: "",
        });
      
        const [loading, setLoading] = useState(false);
        const [message, setMessage] = useState("");
      
        const handleChange = (e) => {
          setFormData({
            ...formData,
            [e.target.name]: e.target.value,
          });
        };
      
        const handleSubmit = async (e) => {
          e.preventDefault(); // ✅ Prevents page reload
        
          setMessage("");
          setLoading(true);
        
          // Validate input
          if (!formData.name || !formData.email || !formData.comments) {
            setMessage("All fields are required.");
            setLoading(false);
            return;
          }
          if (!privacyChecked1) {
            setMessage("Please agree to the privacy policy before subscribing.");
            setLoading(false);
            return;
          }
        
          try {
            const response = await fetch("https://api.brevo.com/v3/smtp/email", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "api-key": process.env.REACT_APP_BREVO_API_KEY, // Use environment variables for security
              },
              body: JSON.stringify({
                sender: { email: "caner.phlvn@gmail.com" },
                to: [{ email: "caner.phlvn@gmail.com" }],
                subject: "MortalAI - New Contact Form Submission",
                htmlContent: `
                  <p><strong>Name:</strong> ${formData.name}</p>
                  <p><strong>Email:</strong> ${formData.email}</p>
                  <p><strong>Message:</strong><br>${formData.comments}</p>
                `,
              }),
            });
        
            const data = await response.json();
            console.log(data);
        
            if (!response.ok) {
              throw new Error(data.message || "Failed to send email");
            }
        
            setMessage("Email sent successfully!");
            setFormData({ name: "", email: "", comments: "" }); // Reset form fields
          } catch (error) {
            console.error("Error sending email:", error);
            setMessage("Error sending email.");
          } finally {
            setLoading(false);
          }
        };
        
  
      useEffect(() => {
          document.documentElement.setAttribute("dir", "ltr");
          document.documentElement.classList.add('light');
          document.documentElement.classList.remove('dark');
        }, []);
  
    return(
        <>
        <Navbar/>
        <section className="relative overflow-hidden pt-48 after:content-[''] after:absolute after:inset-0 after:mx-auto after:w-[56rem] after:h-[56rem] after:bg-gradient-to-tl after:to-amber-400/30  after:from-fuchsia-600/30 dark:after:to-amber-400/50 dark:after:from-fuchsia-600/50 after:blur-[200px] after:rounded-full after:-z-1">
            <div className="container relative z-2">
                <div className="grid grid-cols-1 text-center">
                    <div className="">
                        <h4 className="font-bold lg:leading-normal leading-normal text-4xl lg:text-6xl mb-5">The AI Marketplace <br/>for 
                            <TypeAnimation
                                sequence={[
                                    // Same substring at the start will only be typed out once, initially
                                    'EU users',
                                    1000
                                ]}
                                wrapper="span"
                                speed={10}
                                style={{ backgroundColor: "black" }}
                                className="typewrite text-transparent bg-clip-text ms-4"
                               
                                />
                        </h4>
                        <p className="text-slate-400 dark:text-white/60 text-lg max-w-xl mx-auto">We help you to find right AI products which are compliant with European regulations!</p>

                        <div className="subscribe-form mt-6 mb-3">
                        <form onSubmit={handleSubscribe} className="relative max-w-md mx-auto text-center">
                            <div className="relative">
                            <i className="mdi mdi-email-outline text-xl absolute top-3 start-5"></i>
                            <input
                                type="email"
                                id="aiemail"
                                name="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)} // ✅ Updates state on input change
                                className="py-4 pe-40 ps-12 w-full h-[50px] outline-none text-slate-900 dark:text-white rounded-md bg-white/60 dark:bg-slate-900/60 shadow dark:shadow-gray-800"
                                placeholder="Enter your email"
                                required
                            />
                            </div>
                            <button
                            type="submit"
                            style={{ backgroundColor: "black" }}
                            className="py-2 px-5 inline-block font-semibold tracking-wide align-middle duration-500 text-base text-center absolute top-[2px] end-[3px] h-[46px]  text-white rounded-md"
                            disabled={loading}
                            >
                            {loading ? "Joining..." : "Join Waitlist"}
                            </button>
                        </form>
                        {messagesub && <p className="text-center mt-2">{messagesub}</p>}
                        </div>
                        <div >
                                    <input
                                        type="checkbox"
                                        id="privacyPolicy"
                                        checked={privacyChecked}
                                        onChange={() => setPrivacyChecked(!privacyChecked)}
                                        className="mr-2"
                                    />
                                    <label htmlFor="privacyPolicy" className="text-slate-400 dark:text-white/60" style={{fontWeight: "200"}}>
                                        I agree to the <Link to="/privacy-policy"  className="underline text-blue-600">Privacy Policy</Link>
                                    </label>
                                </div>
                    <div>
                    </div>
                    
                    
                    </div>
                    <div className="relative mt-10 mb-8 z-3">
                        <img src={bannerImg} alt="" className="mover"/>
                    </div>
                    <p className="mt-4 mb-6">
                        Do you have a product on the EU market?  
                        <a href="https://tally.so/r/31N81p" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "underline", fontWeight: "600", marginLeft: "8px" }} className="text-blue-600 underline font-semibold hover:underline">
                             Market it Free.
                        </a>
                    </p>
                </div>
            </div>
            
            <div className="relative after:content-[''] after:absolute lg:after:-bottom-40 after:-bottom-28 after:end-0 after:start-0 after:mx-auto xl:after:w-[56rem] lg:after:w-[48rem] md:after:w-[32rem] after:w-[22rem] xl:after:h-[56rem] lg:after:h-[48rem] md:after:h-[32rem] after:h-[22rem] after:border-2 after:border-dashed after:border-slate-700/10 dark:after:border-slate-200/10 after:rounded-full after:-z-1 before:content-[''] before:absolute lg:before:-bottom-72 before:-bottom-56 before:end-0 before:start-0 before:mx-auto xl:before:w-[72rem] lg:before:w-[64rem] md:before:w-[48rem] before:w-[24rem] xl:before:h-[72rem] lg:before:h-[64rem] md:before:h-[48rem] before:h-[24rem] before:border-2 before:border-dashed before:border-slate-700/10 dark:before:border-slate-200/10 before:rounded-full before:-z-1"></div>
           
        </section>


        <section className="relative md:py-24 py-16">
        <div className="grid grid-cols-1 pb-6 text-center">
                    <h3 className="mb-4 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold">Discover AI Products Tailored to <br/>Your Needs – <span className="bg-gradient-to-br from-amber-400 to-fuchsia-600 text-transparent bg-clip-text">Built for EU Standards and Innovation</span></h3>

                    </div>
            <AboutOne/>
            <AboutThree/>
            <AmazingFeatures/>
            <AboutTwo/>      
            <AboutFour/>


            <Faq/>
          
        </section>
        <section className="relative lg:py-24 py-16">
      <div className="container">
        <div className="grid md:grid-cols-12 grid-cols-1 items-center gap-[30px]">
          <div className="lg:col-span-5 md:col-span-6">
            <div className="lg:ms-5">
              <div className="bg-white dark:bg-slate-900 rounded-md shadow dark:shadow-gray-700 p-6">
                <h3 className="mb-6 text-2xl leading-normal font-semibold">Get in touch!</h3>

                {message && (
                  <p className={`mb-4 ${message.includes("success") ? "text-green-600" : "text-red-600"}`}>
                    {message}
                  </p>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="grid lg:grid-cols-12 lg:gap-6">
                    <div className="lg:col-span-6 mb-5">
                      <label htmlFor="name" className="font-semibold">Your Name:</label>
                      <input
                        name="name"
                        id="name"
                        type="text"
                        value={formData.name}
                        onChange={handleChange}
                        className="form-input w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-200 focus:border-amber-400 dark:border-gray-800 dark:focus:border-amber-400 focus:ring-0 mt-2"
                        placeholder="Name"
                      />
                    </div>

                    <div className="lg:col-span-6 mb-5">
                      <label htmlFor="email" className="font-semibold">Your Email:</label>
                      <input
                        name="email"
                        id="email"
                        type="email"
                        value={formData.email}
                        onChange={handleChange}
                        className="form-input w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-200 focus:border-amber-400 dark:border-gray-800 dark:focus:border-amber-400 focus:ring-0 mt-2"
                        placeholder="Email"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1">
                    <div className="mb-5">
                      <label htmlFor="comments" className="font-semibold">Your Comment:</label>
                      <textarea
                        name="comments"
                        id="comments"
                        value={formData.comments}
                        onChange={handleChange}
                        className="form-input w-full py-2 px-3 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-200 focus:border-amber-400 dark:border-gray-800 dark:focus:border-amber-400 focus:ring-0 mt-2 h-40"
                        placeholder="Message"
                      ></textarea>
                    </div>
                  </div>
                  <div >
                                    <input
                                        type="checkbox"
                                        id="privacyPolicy"
                                        checked={privacyChecked1}
                                        onChange={() => setPrivacyChecked1(!privacyChecked1)}
                                        className="ml-2"
                                    />
                                    <label htmlFor="privacyPolicy" className="text-slate-400 dark:text-white/60">
                                        I agree to the <Link to="/privacy-policy" style={{ textDecoration: "underline"}}  className="underline text-blue-600">Privacy Policy</Link>
                                    </label>
                  </div>

                  <button
                    type="submit"
                    style={{ backgroundColor: "black" }}
                    className="py-2 mt-2 px-5 inline-block font-semibold tracking-wide border align-middle duration-500 text-base text-center text-white rounded-md"
                    disabled={loading}
                  >
                    {loading ? "Sending..." : "Send Message"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
        <Footer/>
  
        </>
    )
}